/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-globals */

import Keycloak from "keycloak-js";

const options = {
	url: `${import.meta.env.VITE_BASE_URL}/auth`,
	realm: import.meta.env.VITE_REALM,
	clientId: import.meta.env.VITE_CLIENT_ID
};

const keycloakInstance = new Keycloak(options);

const Login = (onAuthenticatedCallback) => {
  keycloakInstance
    .init({
      onLoad: 'check-sso',
      pkceMethod: 'S256',
      checkLoginIframe: false,
      silentCheckSsoRedirectUri:
        window.location.origin + '/fgtas-web/silent-check-sso.html'
    })
    .then((authenticated) => {
      if (authenticated) {
        onAuthenticatedCallback();
      } else {
        // Se não estiver logado, abre a tela de login
        keycloakInstance.login({ redirectUri: window.location.toString() });
      }

    })
    .catch((e) => {
      console.error('Keycloak init error:', e);
    });
};


const KeyCloakService = {
	CallLogin: Login,
};

const getToken = () => {
	return keycloakInstance.token;
};

const redirectLogin = () => {
	keycloakInstance.login({ redirectUri: window.location.toString() });
};

const updateToken = (successCallback) => {
	return keycloakInstance.updateToken(5)
		.then(successCallback)
		.catch(() => {
			console.error("Failed to refresh token");
		});
};
const keycloakLogout = () => {
  keycloakInstance
    .logout({
      redirectUri: import.meta.env.VITE_URL_LOGOUT
    })
    .then(() => {
      // Só limpa o storage DEPOIS que o Keycloak finaliza o logout
      localStorage.clear();
      sessionStorage.clear();
    })
    .catch((err) => {
      console.error("Erro ao fazer logout no Keycloak:", err);
    });
};

export { KeyCloakService, keycloakInstance, getToken, updateToken, redirectLogin, keycloakLogout };
